import InventoryIcon from '~/components/SvgIcons/InventoryIcon.vue';
import GamesIcon from '~/components/SvgIcons/GamesIcon.vue';
import ShareIcon from '~/components/SvgIcons/ShareIcon.vue';
import SocialIcon from '~/components/SvgIcons/SocialIcon.vue';
import SendIcon from '~/components/SvgIcons/SendIcon.vue';
import ConvertIcon from '~/components/SvgIcons/ConvertIcon.vue';
import NodeIcon from '~/components/SvgIcons/NodeIcon.vue';
import StoreIcon from '~/components/SvgIcons/StoreIcon.vue';

export default {
  icons: {
    iconfont: 'fa',
    values: {
      convert: {
        component: ConvertIcon,
      },
      games: {
        component: GamesIcon,
      },
      inventory: {
        component: InventoryIcon,
      },
      nodes: {
        component: NodeIcon,
      },
      send: {
        component: SendIcon,
      },
      share: {
        component: ShareIcon,
      },
      social: {
        component: SocialIcon,
      },
      store: {
        component: StoreIcon,
      },
    },
  },
  theme: {
    dark: false,
    options: {
      customProperties: true,
      minifyTheme: (css) => css.replace(/\n/g, '').replace(/\s\s+/g, ' '),
    },
    themes: {
      dark: {
        accent: {
          base: '#161618',
          darken1: '#0A0202',
        },
        accent1: '#011B36',
        accent2: '#161618',
        accent3: '#383A45',
        accentBerry: '#262262',
        accentBlue: '#268AEF',
        accentBlueDark: '#011B36',
        accentBlueLight: '#58afe4',
        accentBlueLightSecondary: '#1483E0',
        accentGold: '#dcb577',
        accentGray3: '#828282',
        accentLight: '#c9d6df',
        accentTeal: '#2af1fd',
        accentPink: '#FF34A2',
        accentPurple: '#7633FF',
        accentPurpleAccessible: '#8F58FF',
        accentPurpleDark: '#281155',
        accentPurpleLight: '#D9C1FF',
        accentPurpleMuted: '#D9C1FF',
        accentPurpleTransparent: '#D9C1FF',
        accentRed: '#DF5B30',
        accentLightGray: '#E6E6E6',
        accentRed: '#ff4747',
        accentRedDark: '#490e0e',
        accentRedLight: '#fdd3d5',
        anchor: '#ffffff',
        error: '#ff5252',
        grayDarkest: {
          darken1: '#0e0e0e',
          base: '#1c1c1e',
          lighten1: '#38383A',
          lighten2: '#2F2F33',
          lighten3: '#49494B',
        },
        modalBackground: '#52616b',
        modalGray: {
          base: '#8C9FAC',
          darken1: '#3E4950',
        },
        pageBackground: {
          base: '#000000',
          lighten1: '#090909',
          lighten2: '#0F0D10',
        },
        pageBackgroundDark: '#000000',
        primary: '#454545',
        secondary: '#2b2b30',
        success: '#4caf50',
        textColor: {
          base: '#ffffff',
          darken1: '#c3c2c3',
          darken2: '#9c9c9c',
        },
        textColorDarkBg: '#ffffff',
        textDarkGray: '#0A0A0A',
        textLightGray: '#c3c2c3',
        textMediumGray: '#6B7077',
      },
      light: {
        accent: {
          base: '#161618',
          darken1: '#0A0202',
        },
        accent1: '#011B36',
        accent2: '#161618',
        accent3: '#383A45',
        accentAqua: '#1857BE',
        accentBerry: '#262262',
        accentBlue: '#268AEF',
        accentBlueDark: '#011B36',
        accentBlueLight: '#58afe4',
        accentBlueLightSecondary: '#1483E0',
        accentGold: '#dcb577',
        accentGrayDark: '#0A0A0A',
        accentGrayLight: '#c3c2c3',
        accentGrayLightBlue: '#F2F5F7',
        accentLight: '#858C94',
        accentTeal: '#2af1fd',
        accentPink: '#FF34A2',
        accentPurple: '#7633FF',
        accentPurpleAccessible: '#8F58FF',
        accentPurpleRoyal: '#250062',
        accentPurpleDark: '#281155',
        accentPurpleLight: '#D9C1FF',
        accentPurpleMuted: '#220066',
        accentPurpleTransparent: '#D9C1FF',
        accentMediumDarkGray: '#858585',
        accentMediumGray: '#DADADA',
        accentRed: '#DF5B30',
        accentLightGray: '#E6E6E6',
        accentRed: '#ff4747',
        accentRedDark: '#490e0e',
        accentRedLight: '#fdd3d5',
        anchor: '#011B36',
        error: '#dd2d01',
        grayDarkest: {
          darken1: '#0e0e0e',
          base: '#1c1c1e',
          lighten1: '#282828',
          lighten2: '#38383A',
          lighten3: '#49494B',
        },
        modalBackground: '#FFFFFF',
        modalGray: {
          base: '#8C9FAC',
          darken1: '#3E4950',
        },
        pageBackground: {
          base: '#ffffff',
          darken1: '#f8f8f8',
          darken2: '#e5e5e5',
        },
        pageBackgroundDark: '#000000',
        primary: '#454545',
        secondary: '#f8f8f8',
        success: '#39843b',
        textColor: {
          base: '#0A0A0A',
          lighten1: '#545454',
          lighten2: '#858585',
        },
        textColorDarkBg: '#ffffff',
        textDarkGray: '#0A0A0A',
        textLightGray: '#c3c2c3',
        textMediumGray: '#6B7077',
      },
    },
  },
};
